export default "__VITE_ASSET__C9wa0m3x__"